// extracted by mini-css-extract-plugin
module.exports = {"download-link-icon":"ExtendedLink_download-link-icon__oyavM","download-btn":"ExtendedLink_download-btn___37F0"};